<template>
  <modal ref="modal" @close="completeHandler(false)">
    <template #title>
      <h4>{{ title }}</h4>
    </template>
    <template #content>
      <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
      <padding direction="vertical" size="medium-large" v-html="text"/>
      <modal-actions submit-button-label="Confirm"
                     @cancel="completeHandler(false)"
                     @submit="completeHandler(true)"/>
    </template>
  </modal>
<!--  <b-modal-->
<!--    :visible="visible"-->
<!--    :header-class="`offer-colour green`"-->
<!--    @hide="onComplete"-->
<!--    :title="title || 'Confirm?'"-->
<!--    hide-footer-->
<!--    no-close-on-backdrop-->
<!--  >-->
<!--    <template #default="{ hide }">-->
<!--      <p>{{ text }}</p>-->
<!--      <OptionButton-->
<!--        v-for="option in options"-->
<!--        :key="option.value"-->
<!--        :option="option"-->
<!--        @click="hide({ option: $event })"-->
<!--      />-->
<!--    </template>-->

<!--  </b-modal>-->

</template>

<script lang="js">
import { mapState } from 'vuex'
import { path } from 'ramda'
import dig from 'spiceutils/dist/dig'
import Padding from '../../Utils/Padding'
import Modal from '../../Modal'
import ModalActions from '../../ModalActions'

export default {
  name: 'ConfirmationModal',
  components: {
    ModalActions,
    Modal,
    Padding,
  },
  computed: {
    ...mapState(
      {
        confirmations: path(['confirmations', 'confirmations']),
      },
    ),
    visible() {
      return this.confirmations.length > 0
    },
    confirmation() {
      return this.confirmations[0]
    },
    title() {
      return dig(this.confirmation, 'title')
    },
    text() {
      return dig(this.confirmation, 'text')
    },
    options() {
      const options = dig(this.confirmation, 'options')
      return options || [{
        value: false,
      }, {
        value: true,
      }]
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        this.$refs.modal.openModal()
      } else {
        this.$refs.modal.closeModal()
      }
    },
  },
  methods: {
    completeHandler(accepted) {
      if (this.confirmation) {
        this.confirmation.resolve(accepted)
      }
    },
  },
}
</script>
